import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
  getKitchenCsrf,
  getKitchenUser,
  kitchenLogin,
} from "./kitchenApi";

import "./kitchen.css";

export default function KitchenLogin() {
  const { restaurantId } = useParams();
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [csrfToken, setCsrfToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    async function initialize() {
      try {
        const csrf = await getKitchenCsrf();

        if (!active) return;

        setCsrfToken(csrf.csrfToken);

        try {
          await getKitchenUser(restaurantId);

          if (active) {
            navigate(
              `/kitchen/${restaurantId}/dashboard`,
              { replace: true }
            );
          }
        } catch {
          // No active authorized kitchen session.
        }
      } catch {
        if (active) {
          setError("Unable to connect to the server.");
        }
      } finally {
        if (active) {
          setChecking(false);
        }
      }
    }

    initialize();

    return () => {
      active = false;
    };
  }, [restaurantId, navigate]);

  async function handleSubmit(event) {
    event.preventDefault();

    setError("");
    setLoading(true);

    try {
      let token = csrfToken;

      if (!token) {
        const csrf = await getKitchenCsrf();
        token = csrf.csrfToken;
        setCsrfToken(token);
      }

      await kitchenLogin(
        restaurantId,
        username,
        password,
        token
      );

      navigate(
        `/kitchen/${restaurantId}/dashboard`,
        { replace: true }
      );
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  if (checking) {
    return (
      <div className="kitchen-login-page">
        <p>Checking kitchen session...</p>
      </div>
    );
  }

  return (
    <div className="kitchen-login-page">
      <div className="kitchen-login-card">
        <div className="kitchen-login-icon">👨‍🍳</div>

        <h1>Kitchen Login</h1>

        <p className="kitchen-login-subtitle">
          Restaurant #{restaurantId}
        </p>

        <form onSubmit={handleSubmit}>
          <label htmlFor="kitchen-username">
            Username
          </label>

          <input
            id="kitchen-username"
            type="text"
            autoComplete="username"
            value={username}
            onChange={(event) =>
              setUsername(event.target.value)
            }
            required
          />

          <label htmlFor="kitchen-password">
            Password
          </label>

          <input
            id="kitchen-password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) =>
              setPassword(event.target.value)
            }
            required
          />

          {error && (
            <div className="kitchen-login-error" role="alert">
              {error}
            </div>
          )}

          <button type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Login to Kitchen"}
          </button>
        </form>
      </div>
    </div>
  );
}